import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomHeaderCategoryComponent} from './custom-header-category.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {effectsCategory} from './store/effects/custom-category.effect';
import {CATEGORY_FEATURE} from './store/custom-category-state';
import {reducerCategoryProvider, reducerCategoryToken} from './store/reducers/custom-category.reducer';
import {CustomCarouselModule} from 'src/app/spartacus/custom/shared/components/custom-carousel/custom-carousel.module';
import {MediaModule} from "@spartacus/storefront";
import {CustomProductCarouselModule} from "../../../../spartacus/custom/cms-components/product/carousel/custom-product-carousel/custom-product-carousel.module";
import {CustomAddToCartModule} from "../../../../spartacus/custom/cms-components/cart/custom-add-to-cart/custom-add-to-cart.module";
import {CustomProductItemModule} from "../custom-product-item/custom-product-item.module";


@NgModule({
  declarations: [CustomHeaderCategoryComponent],
  imports: [
    CommonModule,
    I18nModule,
    CustomCmsItemModule,
    MediaModule,
    CustomCarouselModule,
    CustomProductCarouselModule,
    CustomProductItemModule,
    CustomAddToCartModule,
    EffectsModule.forFeature(effectsCategory),
    StoreModule.forFeature(CATEGORY_FEATURE, reducerCategoryToken),
    ConfigModule.withConfig({
      cmsComponents: {
        HeaderCategoryComponent: {
          component: CustomHeaderCategoryComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [reducerCategoryProvider],
})
export class CustomHeaderCategoryModule { }
